import { Icon } from '@rsuite/icons';

import { coloursHex } from '../constants';

export const DisplayIcon = ({ icon }) => {
  return (
    <div
      style={
        icon !== undefined
          ? {
              border: '1px solid',
              borderColor: 'lightgray',
              borderRadius: '5px',
              padding: '5px',
              boxShadow: '1px -1px 0 lightgray',
            }
          : { border: 'none' }
      }
    >
      {icon !== undefined ? (
        // @ts-expect-error - rsuite Icon props type rejects valid runtime values
        <Icon as={icon} color={coloursHex.default} size="2em" />
      ) : (
        ' '
      )}
    </div>
  );
};
